import ControlVideo from './ControlVideo';

const controlVideo = new ControlVideo();
export default class ControlSwiper {
  constructor() {
    this.classes = {
      jsVideoSwiper: 'js-video-swiper',
      buttonPlayPause: 'btn-play-pause',
    };
  }

  playVideoOnSlide($slide, idIframe, listVideo) {
    if (!$slide.find(`.${this.classes.buttonPlayPause}`).hasClass('is-click-pause')) {
      controlVideo.playVideo(
        $slide.find(`.${this.classes.buttonPlayPause}`),
        idIframe,
        listVideo,
      );
    }
  }

  handlePauseOrPlayVideo(event, $element, listVideo) {
    if (event && event.slides && event.slides.length) {
      const indexCurrentSlide = event.realIndex;
      const slidesLength = event.slides.length;
      const snapGridLength = event.snapGrid.length;
      const slidesPerView = slidesLength - snapGridLength + 1;
      const noInScreenClassName = 'no-in-screen';

      $element.find(`.${this.classes.jsVideoSwiper}`).addClass(noInScreenClassName);
      controlVideo.pauseAllVideo(
        $element.find(`.${this.classes.buttonPlayPause}`),
        listVideo,
      );

      $(event.slides).each((index, elm) => {
        const $jsVideoSwiperPerView = $(elm).find(`.${this.classes.jsVideoSwiper}`);
        if (index >= indexCurrentSlide && index < slidesPerView + indexCurrentSlide && $jsVideoSwiperPerView.length > 0) {
          const idIframeSlidesPerView = $jsVideoSwiperPerView.attr('id');
          $jsVideoSwiperPerView.removeClass(noInScreenClassName);
          this.playVideoOnSlide($(elm), idIframeSlidesPerView, listVideo);
        }
      });
    }
  }
}
